<template>
  <el-dialog
    v-loading="loading"
    title="导入材料台账"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false"
    append-to-body
    @close="closeDialog"
  >
    <el-form ref="importForm" class="import-form" :model="importForm" label-position="right" label-width="120px">
      <el-form-item label="获取模板">
        <el-button type="success" icon="el-icon-download" plain @click="downloadTemplate">
          下载导入模板
        </el-button>
      </el-form-item>
      <el-form-item label="上传文件">
        <input ref="fileInput" type="file" accept=".xlsx" @change="handleFileChange">
      </el-form-item>
      <el-form-item label="备注">
        <div class="import-tips">
          <p>1、请严格按照模板填写；未下载模板请点击【下载导入模板】。</p>
          <p>2、仅支持 .xlsx，大小不超过 10M。</p>
          <p>3、材料类型可填字典键值或中文标签；初始库存、预警阈值为非负整数，可空。</p>
        </div>
      </el-form-item>
      <el-form-item v-if="importFlag" label="导入结果">
        <div class="import-result">
          <p><strong>导入结果：</strong></p>
          <p class="result-summary">
            您总共导入{{ importResult.total }}条记录，成功{{ importResult.successNum }}条，失败{{ importResult.failNum }}条。
          </p>
          <div v-if="importResult.failNum > 0" class="error-list">
            <strong>其中错误信息如下:</strong>
            <ul>
              <li v-for="(item, index) in importResult.errMsgs" :key="index" class="error-item">
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" icon="el-icon-upload2" :loading="loading" @click="handleImport">导入</el-button>
      <el-button icon="el-icon-close" @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { materialService } from './material.service';
import { downloadFromApiBlobResponse } from '@/features/common/utils/downloadFileUtil.js';

export default {
  name: 'ImportMaterialDialog',
  props: {
    visible: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false,
      importForm: {},
      importResult: { total: 0, failNum: 0, successNum: 0, errMsgs: [] },
      importFlag: false,
      selectedFile: null
    };
  },
  computed: {
    dialogVisible: {
      get () { return this.visible; },
      set (val) { this.$emit('update:visible', val); }
    }
  },
  methods: {
    downloadTemplate () {
      this.loading = true;
      materialService.downloadMaterialTemplate().then(res => {
        downloadFromApiBlobResponse(res, '材料台账导入模板.xlsx');
      }).finally(() => { this.loading = false; });
    },
    handleFileChange (e) {
      const files = e.target.files;
      if (files && files.length > 0) this.selectedFile = files[0];
    },
    handleImport () {
      if (!this.selectedFile) {
        this.$message.warning('请先选择要导入的文件');
        return;
      }
      if (this.selectedFile.size / 1024 / 1024 > 10) {
        this.$message.warning('导入文件过大，请控制在10M以内');
        return;
      }
      if (!this.selectedFile.name.endsWith('.xlsx')) {
        this.$message.warning('请上传.xlsx格式的文件');
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      materialService.importMaterial(formData).then(res => {
        this.importFlag = true;
        this.importResult = {
          total: res.data.total || 0,
          failNum: res.data.failNum || 0,
          successNum: res.data.successNum || 0,
          errMsgs: []
        };
        if (res.data.failNum > 0 && res.data.importExcelErrors) {
          this.importResult.errMsgs = res.data.importExcelErrors.map(
            err => `第${err.id}行出现错误：${err.desc}`
          );
        }
        this.$emit('success');
      }).finally(() => { this.loading = false; });
    },
    closeDialog () {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm () {
      this.selectedFile = null;
      this.importFlag = false;
      this.importResult = { total: 0, failNum: 0, successNum: 0, errMsgs: [] };
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    }
  }
};
</script>

<style scoped lang="scss">
.import-form {
  padding: 10px 10px 0;
  ::v-deep .el-form-item { margin-bottom: 25px; }
  .import-tips {
    font-size: 13px; color: #606266; line-height: 2;
    background-color: #f8f9fa; padding: 12px 15px; border-radius: 4px; border: 1px solid #ebeef5;
    p { margin-bottom: 4px; &:last-child { margin-bottom: 0; } }
  }
  .import-result {
    .result-summary { color: #409eff; margin: 5px 0 15px; }
    .error-list ul { margin: 10px 0; padding-left: 20px; }
    .error-item { color: #f56c6c; margin-bottom: 5px; }
  }
}
</style>
